import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { createDocumentsConfirming } from 'lib/api/confirming';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import { showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AddDocumentsCSV from './csvParse';
import AddDocumentsForm from './form';

interface AddDocumentsConfirmingProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  stakeholderIdentifier: string;
  handleSearchSuggestedDocuments: () => void;
}

export interface NewDocument {
  folio: string;
  businessIdentifier: string;
  businessName: string;
  stakeholderIdentifier: string;
  issuedDate: string;
  amount: number;
  subType: string;
}

const AddDocumentsConfirming = (props: AddDocumentsConfirmingProps) => {
  const {
    open,
    setOpen,
    stakeholderIdentifier,
    handleSearchSuggestedDocuments,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState<NewDocument[]>([]);
  const [inputType, setInputType] = useState<string | null>(null);

  const uploadDocuments = async () => {
    setLoading(true);
    try {
      const formatDocumentsWithDate = documents.map((invoice) => {
        return {
          ...invoice,
          issuedDate: new Date(invoice.issuedDate).toISOString(),
        };
      });
      await createDocumentsConfirming(dispatch, {
        documents: formatDocumentsWithDate,
        stakeholderIdentifier: stakeholderIdentifier,
      });
      void handleSearchSuggestedDocuments();
      setOpen(false);
      showAlert(dispatch, 'success', 'Documentos agregados correctamente');
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Error al agregar documentos');
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog maxWidth="md" open={open}>
        <DialogTitle>
          <HeaderWithActions title="Agregar facturas" type="dialogHeader" />
        </DialogTitle>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <DialogContent>
            {!inputType ? (
              <div>
                <Typography variant="body1">
                  Acá podrás agregar facturas de manera manual. Puedes hacerlo
                  ingresando las facturas o ingresando un archivo xlsx con las
                  facturas.
                </Typography>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      width: '80%',
                      padding: 30,
                      margin: 'auto',
                    }}
                  >
                    <CustomButton
                      color="primary"
                      onClick={() => {
                        setInputType('manual');
                      }}
                    >
                      Manual
                    </CustomButton>
                    <CustomButton
                      color="primary"
                      onClick={() => {
                        setInputType('sii');
                      }}
                    >
                      XLSX
                    </CustomButton>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {inputType === 'manual' ? (
                  <AddDocumentsForm
                    documents={documents}
                    setDocuments={setDocuments}
                    stakeholderIdentifier={stakeholderIdentifier}
                  />
                ) : (
                  <AddDocumentsCSV
                    setDocuments={setDocuments}
                    stakeholderIdentifier={stakeholderIdentifier}
                  />
                )}
              </div>
            )}
            <div>
              {documents.length > 0 && (
                <div>
                  <Typography variant="body1">Documentos:</Typography>
                  <div>
                    <EnhancedTable
                      dataHeaders={[
                        {
                          key: 'subType',
                          label: 'Tipo',
                          type: 'invoice-sub-type',
                        },
                        { key: 'folio', label: 'Folio' },
                        { key: 'businessIdentifier', label: 'Rut proveedor' },
                        { key: 'businessName', label: 'Nombre proveedor' },
                        {
                          key: 'issuedDate',
                          label: 'Fecha emisión',
                          type: 'date',
                        },
                        { key: 'amount', label: 'Monto', type: 'money' },
                      ]}
                      data={documents}
                      finalSumRow
                    />
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
        )}
        <DialogActions>
          {documents.length && !loading ? (
            <CustomButton color="primary" onClick={() => uploadDocuments()}>
              Guardar
            </CustomButton>
          ) : null}
          <CustomButton
            onClick={() =>
              inputType && documents.length
                ? setInputType(null)
                : setOpen(false)
            }
            color="secondary"
          >
            Volver
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddDocumentsConfirming;
